var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListingTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 31,
    viewBox: "0 0 64 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13300_53551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2308 7.5H22.7692C22.5652 7.5 22.3696 7.58429 22.2253 7.73431C22.081 7.88434 22 8.08783 22 8.3V21.9C22 22.3243 22.1621 22.7313 22.4506 23.0314C22.7391 23.3314 23.1304 23.5 23.5385 23.5H40.4615C40.8696 23.5 41.2609 23.3314 41.5494 23.0314C41.8379 22.7313 42 22.3243 42 21.9V8.3C42 8.08783 41.919 7.88434 41.7747 7.73431C41.6304 7.58429 41.4348 7.5 41.2308 7.5ZM23.5385 13.9H27.3846V17.1H23.5385V13.9ZM28.9231 13.9H40.4615V17.1H28.9231V13.9ZM40.4615 9.1V12.3H23.5385V9.1H40.4615ZM23.5385 18.7H27.3846V21.9H23.5385V18.7ZM40.4615 21.9H28.9231V18.7H40.4615V21.9Z",
    fill: "#5D5D5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13300_53551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 31,
    rx: 15.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingTab);
export default __webpack_public_path__ + "static/media/listingTab.9bd380c2d30a213daca46f7e430c230f.svg";
export { ForwardRef as ReactComponent };